import { render, staticRenderFns } from "./SettingsBotMarketEditor.vue?vue&type=template&id=4462790d&"
import script from "./SettingsBotMarketEditor.vue?vue&type=script&lang=js&"
export * from "./SettingsBotMarketEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports